<template>
  <el-dialog
    class="commonDialog clickLight"
    title="选择部门"
    :visible.sync="departopen"
    width="600px"
    append-to-body
    :before-close="closeDialog"
    :close-on-click-modal="false"
  >
    <div class="head-container" style="height: 600px;overflow: scroll;">
          <el-tree
            :data="deptOptions"
            :props="defaultProps"
            :expand-on-click-node="false"
            show-checkbox
          @check-change="handleCheckChange"
            ref="tree"
            node-key="deptId"
            default-expand-all
            highlight-current
            :default-checked-keys="defaultKeys"
          />
        </div>
    <span slot="footer" class="commonDialog-footer">
      <el-button type="primary" @click="distribeHttp">确 定</el-button>
      <el-button @click="closeDialog">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'selectInitiator',
  components: {
    // checkbox,
  },
  data() {
    return {
      deptId: '', // 部门ID
      // 总条数
      total: 0,
      // 遮罩层
      loading: true,
      // 部门名称
      name: undefined,
      // 部门树选项
      deptOptions: undefined,
      defaultProps: {
        children: 'children',
        label: 'deptName',
      },
      selectedDepartList: [],
      defaultKeys: []
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: () => false,
    },
    departopen: {
      type: Boolean,
      required: true,
      default: false,
    },
    // 勾选人员 数组
    selectdepartList: {
      type: Array,
      default: [],
    },
    // 公司ID
    companyId: {
      type: String,
      default: () => '',
    },
    url: {
      type: String,
      default: () => '',
    },
    checkedList: {
      type: Array,
      default: () => [],
    },
    peopleOrdepart: {
      type: String,
      default:()=>'',
    }
  },
  mounted() {
    this.getDeptTree()
    this.defaultKeys = []
    this.$nextTick(() => {
      console.log(this.selectdepartList)
      for (let i = 0; i < this.selectdepartList.length; i++) {
        const e = this.selectdepartList[i]
          this.defaultKeys.push(e.deptId)
      }
      console.log( this.defaultKeys)
      this.selectedDepartList  = this.selectdepartList
    /*   this.selectdepartList.forEach((row) => {
        this.$refs.multipleTable.toggleRowSelection(row, true) // 回显
      }) */
    })
  },
  methods: {
    /** 查询部门下拉树结构 */
    getDeptTree() {
      axios({
        // url: this.url + "/OA/treeList?companyId=" + this.companyId,
        url: this.url + '/system/dept/treeList?companyId=' + this.companyId,
      }).then((res) => {
        if (res.data.code == 200) {
          this.deptOptions = res.data.data
        }
      })
    },
    remove(array, val) {
      for (var i = 0; i < array.length; i++) {
        if (array[i] === val) {
          array.splice(i, 1)
        }
      }
      return -1
    },
    handleCheckChange(data, checked, indeterminate) {
      // indeterminate是否包含半节点，data会把每一上级也显示出来
        // console.log(data, checked, indeterminate);
        // if(this.myRepairInfo)
        if(checked && data.children.length ==0){
          this.selectedDepartList.push(data)
        }else if(!checked && data.children.length ==0){
          for (let i = 0; i < this.selectedDepartList.length; i++) {
            const e = this.selectedDepartList[i]
            if(e.deptId  == data.deptId){
              this.remove(this.selectedDepartList, e)
            }
          }
        }
        console.log('selectedDepartList',this.selectedDepartList)
        // console.log(this.selectedDepartList)
      },
    // 关闭弹窗
    closeDialog() {
      /*  this.$emit('closedepartTree', this.selectedDepartList)
      this.$emit('departopen', false) */
      this.$emit('update',2)
    },

    // 确定按钮
    distribeHttp() {
      // if (this.selectedDepartList.length <= 0) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请选择部门',
      //   })
      //   return
      // } else {
      //
      // }
      this.$emit('getdepartSelectList', this.selectedDepartList)
      this.$emit('departopen', false)
      this.$emit('update',1)
    },
  },
}
</script>

<style lang="less" scoped>
//去掉横向滚动条
/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}

.treeWrap {
  padding: 20px 30px 10px 30px;

  .titleTree1 {
    color: #333333;
    font-size: 14px;
    padding-left: 16px;
    margin-top: 8px;
    border: 1px solid #e5e5e5;
    border-bottom: none;
    height: 40px;
    line-height: 40px;
  }
  .treeLeft1 {
    overflow: hidden;
    border: 1px solid #e5e5e5;
    border-right: none;
    height: 480px;
    overflow-y: auto;
    .tabType {
      padding: 20px 14px 15px 14px;
      display: flex;
      .button {
        flex: 1;
        border: 1px solid #e5e5e5;
        text-align: center;
        height: 28px;
        line-height: 28px;
        font-size: 14px;
        color: #333;
        border-radius: 4px 0px 0px 4px;
      }
      .button:nth-child(2) {
        border-radius: 0px 4px 4px 0px;
        border-left: 0;
      }
      .checked {
        background-color: #1890ff;
        color: #fff;
      }
    }
    .organization,
    .roleList {
      .departmentBox {
        padding: 0 14px;
        display: inline-block;
        white-space: nowrap;
        .content {
          display: inline-block;
          width: 300px;
          overflow: hidden;
          .structureBox {
            display: inline-block;
            white-space: nowrap;
            .structure {
              display: inline-block;
              .iconfont {
                font-size: 14px;
              }
              .active {
                color: #1890ff;
              }
            }
          }
        }
      }
      .listBox {
        .listItem {
          padding: 0 14px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .icon-youjiantou {
            font-size: 14px;
            color: #999;
          }
        }
        .listItem:hover {
          background-color: #f7f7f7;
        }
      }
      .textNoDate {
        text-align: center;
        line-height: 370px;
      }
    }
  }
  .treeRight {
    overflow: hidden;
    border: 1px solid #e5e5e5;
    height: 460px;
    padding: 20px 28px 0 20px;
    overflow-y: auto;
    .tableFather1 {
      &.textNoDate {
        text-align: center;
      }
      .noData {
        line-height: 460px;
      }
    }
    .selected {
      .role,
      .department,
      .person {
        margin-bottom: 20px;
        .title {
          font-size: 14px;
          color: #999;
          margin-bottom: 12px;
        }
        .content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          font-size: 14px;
          color: #333;
          .icon-liucheng_bohui {
            font-size: 14px;
            color: #f6747d;
            cursor: pointer;
          }
        }
      }
      .person {
        margin-bottom: 0;
        .imgBox {
          display: flex;
          align-items: center;
          .name {
            margin-left: 6px;
          }
        }
      }
    }
  }
  .text {
    font-size: 14px;
    color: #333333;
    margin-bottom: 12px;
  }
  .userLogo {
    font-size: 20px;
    color: #666;
    border-radius: 50%;
    vertical-align: bottom;
  }
  img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    vertical-align: bottom;
  }
}

/deep/.el-dialog__footer {
  // padding-bottom: 40px;
}
/* 定义滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  // height: 6px;
  background-color: transparent;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.1);
  border-radius: 10px;
  background-color: rgba(240, 240, 240, 0.1);
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  margin-right: 10px;
  border-radius: 10px;
  box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.5);
  background: #bfbfbf;
}

/deep/ .el-dialog {
  margin-top: 2vh !important;
}

/deep/ .pagination-container {
  margin-top: 0;
}
</style>
